<div class="chart-container">
    <canvas id="{{this.chartId}}">{{ chart }} </canvas>
</div>